import React, { Component } from "react";
import Link from "./Link";
import styled from "styled-components";

class BannerBackground extends Component {
  render() {
    let { data } = this.props;

    return (
      <Link to={data.path}>
        <Wrapper img={data.background} />
      </Link>
    );
  }
}

const Wrapper = styled.div`
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
`;

export default BannerBackground;
